/** Роли клуба BaySport (зеркало backend/utils/roles.js). */

const LEGACY = { doctor: "trainer", patient: "client" };

export function normalizeRole(role) {
  return LEGACY[role] || role;
}

export function isClientRole(role) {
  return normalizeRole(role) === "client";
}

export function isTrainerRole(role) {
  const r = normalizeRole(role);
  return r === "trainer" || r === "owner";
}

export function hasAdminAccess(role) {
  const r = normalizeRole(role);
  return r === "admin" || r === "owner";
}

export function hasTrainerAccess(role) {
  const r = normalizeRole(role);
  return r === "trainer" || r === "owner";
}

export function isOwner(role) {
  return normalizeRole(role) === "owner";
}

/** Владелец клуба: роль owner или флаг из /auth/me (club.is_owner). */
export function isClubOwner({ role, profileRole, club } = {}) {
  return (
    isOwner(role) ||
    isOwner(profileRole) ||
    Boolean(club?.is_owner)
  );
}

export function isClubStaff(role) {
  const r = normalizeRole(role);
  return hasAdminAccess(r) || r === "trainer";
}

export function staffNavRole(role) {
  const r = normalizeRole(role);
  if (r === "owner") return "admin";
  return r;
}
